// import React from 'react';
import Dashboard from "views/Front/Dashboard";
import Login from "../Auth/Login";
const FrontRoutes = [
  //{ path: "/", exact: true, name: "Dashboard", component: Dashboard }
  { path: "/", exact: true, name: "Login", component: Login }
];

export default FrontRoutes;
